import { useGetUser } from '@hero/services/organization-service/hooks';
import { storage } from '@hero/utils';

export function useGetMeConfigs() {
  const { data: user } = useGetUser();
  const organizationCode = storage.getOrganizationCode();
  const organization = user?.organizations?.find(o => o.code === organizationCode);

  const CAActMustBeApplied = !!organization?.configs?.CAActMustBeApplied;
  const giftCardStatus = organization?.approvalStatus?.giftCard;

  return {
    CAActMustBeApplied,
    giftCardStatus
  };
}
